__turbopack_context__.v({
  "block": "CompareView-module__VZFwwG__block",
  "close": "CompareView-module__VZFwwG__close",
  "col": "CompareView-module__VZFwwG__col",
  "colHead": "CompareView-module__VZFwwG__colHead",
  "cols": "CompareView-module__VZFwwG__cols",
  "compare-rise": "CompareView-module__VZFwwG__compare-rise",
  "divider": "CompareView-module__VZFwwG__divider",
  "head": "CompareView-module__VZFwwG__head",
  "name": "CompareView-module__VZFwwG__name",
  "noMotion": "CompareView-module__VZFwwG__noMotion",
  "overlay": "CompareView-module__VZFwwG__overlay",
  "panel": "CompareView-module__VZFwwG__panel",
  "researchItem": "CompareView-module__VZFwwG__researchItem",
  "researchList": "CompareView-module__VZFwwG__researchList",
  "researchState": "CompareView-module__VZFwwG__researchState",
  "summary": "CompareView-module__VZFwwG__summary",
  "tagline": "CompareView-module__VZFwwG__tagline",
  "tags": "CompareView-module__VZFwwG__tags",
});
